function initSizeGuide() {
  document.addEventListener("DOMContentLoaded", function () {
    const triggers = document.querySelectorAll(".js-size-guide-trigger");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();

        // Find the closest .c-size-guide
        const guide =
          trigger.closest(".c-size-guide") ||
          trigger.parentElement.querySelector(".c-size-guide");
        if (!guide) return;

        // Toggle open/closed
        if (!guide.classList.contains("active")) {
          const realHeight = guide.scrollHeight; // full height
          guide.style.maxHeight = realHeight + "px";
          guide.classList.add("active");
        } else {
          guide.style.maxHeight = "0px";
          guide.classList.remove("active");
        }
      });
    });
  });
}

initSizeGuide();

export { initSizeGuide };
